import "core-js/modules/es.object.assign";

/* eslint-disable max-depth */
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import EmailCaptureOverlay from "web/react/components/email-capture-overlay/email-capture-overlay";
import withReduxProvider from "web/react/redux-provider";

function mapStateToProps(state) {
  var _state$customerCaptur = state.customerCaptureOverlayReducer,
      captureType = _state$customerCaptur.captureType,
      open = _state$customerCaptur.open;
  return {
    captureType: captureType,
    overlayOpen: open
  };
}

export function CustomerCaptureOverlay(_ref) {
  var props = Object.assign({}, _ref);
  var overlayOpen = props.overlayOpen;

  if (!overlayOpen) {
    return null;
  }

  return React.createElement(React.Fragment, null, React.createElement(EmailCaptureOverlay, props));
}
export default withReduxProvider(connect(mapStateToProps)(CustomerCaptureOverlay));
CustomerCaptureOverlay.propTypes = {
  captureType: PropTypes.oneOf(["signup_lead_save", "signup_pdp_save", "signup_feed_save", "signup_du", "signup_search", "stock_alert", "stock_alert_lead_return", "signup_oos_save", "ta_collection"]),
  overlayOpen: PropTypes.bool
};